import { jsxs as x, jsx as n } from "react/jsx-runtime";
import { u as c } from "./index-6a632112.mjs";
import { s as i, b as C, r as v, f as E, a as f, d as _, e as B } from "./themes-5f0b3c3d.mjs";
import L, { useRef as I, useState as R } from "react";
import { S as N } from "./checkmark-84b5274e.mjs";
import { S } from "./subtract-848336fd.mjs";
import { l as W } from "./lineHeights-72d3110c.mjs";
import { useAccessibilityProps as P } from "./accessibility.js";
import { u as O } from "./uniqueId-321287e8.mjs";
import { L as q } from "./label-3b996c7d.mjs";
import "./types-b577bf77.mjs";
import "./tooltip.js";
import "./useWindowDimensions.js";
import "./zIndices-d07533f3.mjs";
import "./getElementPosition-5026bb28.mjs";
import "./popupTip.js";
import "./closeButton.js";
import "./cancelClose-87fdf326.mjs";
import "./iconButton.js";
import "./button.js";
import "./textStyles-42cab346.mjs";
import "./fontWeights-a25f8f91.mjs";
import "./checkmarkFilled-c2b01ef1.mjs";
import "./informationFilled-05d57719.mjs";
const m = {
  UNCHECKED: 0,
  INTERMEDIATE: 1,
  CHECKED: 2
}, y = "20px", G = c.div`
  padding-bottom: ${i["1x"]};
  display: flex;
  flex-direction: column;

  &[data-component='checkbox-wrapper'] {
  }
`, X = c.div`
  /* Since input element is absolute, it doesn't take space in the parent container */
  margin-left: ${y};
  & > span {
    margin-left: ${i["2x"]};
  }
`, j = c.span`
  position: absolute;
  top: 10px;
  left: 3px;
  cursor: ${(e) => e.isDisabled ? "auto" : "pointer"};
  color: ${(e) => e.error ? e.theme.components.checkbox.checkmarkErrorColor : e.isDisabled ? e.theme.components.checkbox.checkmarkDisabledColor : e.theme.components.checkbox.checkmarkColor};
  & img,
  svg {
    height: 14px !important;
    width: 14px !important;
    color: ${(e) => e.error ? e.theme.components.checkbox.checkmarkErrorColor : e.isDisabled ? e.theme.components.checkbox.checkmarkDisabledColor : e.theme.components.checkbox.checkmarkColor} !important;
  }
`, J = c.input`
  appearance: none;
  -moz-appearance: none; /* stylelint-disable-line */
  -webkit-appearance: none; /* stylelint-disable-line */
  height: ${y};
  width: ${y};
  margin: 0;
  outline-style: solid;
  outline-width: ${C["2x"]};
  outline-offset: -1px;
  border-radius: ${v["1x"]};
  overflow: hidden;
  position: absolute;

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    height: 200%;
    width: 200%;
    background-color: ${(e) => e.theme.components.checkbox.inactiveBackgroundColor};
    border-radius: 50%;
    transform: translate(-50%, -50%) scale(1);
    transition: all 0.12s linear;
  }

  &:disabled {
    &::before {
      background-color: ${(e) => e.theme.components.checkbox.inactiveDisabledBackgroundColor};
    }
    outline-width: ${C["2x"]};
  }
  &:checked {
    &::before {
      transform: translate(-50%, -50%) scale(0);
    }
  }

  &:not(disabled):focus-visible {
    outline-style: solid;
    outline-offset: 2px;
    outline-color: ${(e) => e.error ? e.theme.components.checkbox.errorFocusColor : e.theme.components.checkbox.focusColor};
    outline-width: ${C["2x"]};
    border-radius: ${v["1x"]};
  }
`, Q = c.label`
  display: flex;
  padding-top: ${i["2x"]};
  padding-bottom: ${i["2x"]};
  font-family: ${E.inter};
  font-size: ${f.small};
  position: relative;
  color: ${(e) => e.isDisabled ? e.theme.components.checkbox.disabledFontColor : e.theme.components.checkbox.fontColor};

  cursor: ${(e) => e.isDisabled ? "auto" : "pointer"};
  input {
    cursor: ${(e) => e.isDisabled ? "auto" : "pointer"};
    outline-color: ${(e) => e.error ? e.theme.components.checkbox.inactiveErrorOutlineColor : e.theme.components.checkbox.inactiveOutlineColor};

    background-color: ${(e) => e.error ? e.theme.components.checkbox.activeErrorBackgroundColor : e.theme.components.checkbox.activeBackgroundColor};
    &:checked {
      outline-color: ${(e) => e.error ? e.theme.components.checkbox.activeErrorOutlineColor : e.theme.components.checkbox.inactiveOutlineHoverColor};
      outline-width: 3px;
    }

    &:disabled {
      background-color: ${(e) => e.theme.components.checkbox.inactiveDisabledBackgroundColor};
      outline-color: ${(e) => e.theme.components.checkbox.disabledOutlineColor};
      &:checked {
        background-color: ${(e) => e.theme.components.checkbox.activeDisabledBackgroundColor};
        outline-color: ${(e) => e.theme.components.checkbox.activeDisabledBackgroundColor};
        outline-width: 3px;
      }
    }
  }

  &:hover {
    input:not([disabled]) {
      outline-style: solid;
      outline-width: 3px;
      outline-color: ${(e) => e.error ? e.theme.components.checkbox.inactiveErrorOutlineColor : e.theme.components.checkbox.inactiveOutlineHoverColor};

      &:checked {
        background-color: ${(e) => e.error ? e.theme.components.checkbox.activeHoverErrorBackgroundColor : e.theme.components.checkbox.activeHoverBackgroundColor};
        outline-color: ${(e) => e.error ? e.theme.components.checkbox.activeHoverErrorBackgroundColor : e.theme.components.checkbox.activeHoverBackgroundColor};
      }
    }
  }

  &:active {
    label {
      color: ${(e) => e.isDisabled && e.theme.components.checkbox.checkmarkDisabledActive};
    }
    input {
      &:disabled {
        transition: outline-color 0.12s, background-color 0.12s;
        transition-timing-function: linear;
        outline-width: 3px;
        outline-color: ${(e) => e.theme.components.checkbox.disabledClickColor};

        &:checked {
          outline-width: 2px;
          outline-offset: 0.5px;
          background-color: ${(e) => e.theme.components.checkbox.disabledClickColor};
        }
      }
    }
  }

  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none;
`, Y = c.span`
  margin-left: 30px;
  font-family: ${E.inter};
  font-size: ${f.xsmall};
  overflow-wrap: break-word;
  color: ${(e) => e.isDisabled ? e.theme.components.checkbox.disabledFontColor : e.error ? e.theme.components.checkbox.errorFontColor : e.theme.components.checkbox.fontColor};
`, Ae = ({
  isDisabled: e = !1,
  checkboxValue: o = m.UNCHECKED,
  error: t = !1,
  helperText: l,
  label: s,
  value: d,
  onChange: b = null,
  isIntermediate: k = !1
}) => {
  const u = (p) => {
    k ? (o++, o = o % 3) : o = o === m.UNCHECKED ? m.CHECKED : m.UNCHECKED, b && b(p, o);
  };
  return /* @__PURE__ */ x(G, { "data-component": "checkbox-wrapper", children: [
    /* @__PURE__ */ x(Q, { isDisabled: e, error: t, children: [
      /* @__PURE__ */ n(
        J,
        {
          type: "checkbox",
          "aria-label": "checkbox",
          checked: o > 0,
          checkboxValue: o,
          disabled: e,
          error: t,
          value: d,
          onChange: u
        }
      ),
      o !== m.UNCHECKED && /* @__PURE__ */ n(j, { isDisabled: e, error: t, children: k && o === m.INTERMEDIATE ? /* @__PURE__ */ n(S, {}) : /* @__PURE__ */ n(N, {}) }),
      /* @__PURE__ */ n(X, { children: s && /* @__PURE__ */ n("span", { children: s }) })
    ] }),
    l && /* @__PURE__ */ n(Y, { isDisabled: e, error: t, children: l })
  ] });
}, h = {
  UNCHECKED: 0,
  INTERMEDIATE: 1,
  CHECKED: 2
}, $ = i["5x"], Z = c.div`
  display: flex;
  flex-direction: column;

  &[data-component='checkbox-wrapper'] {
  }
  width: ${({ $width: e }) => `${e}px`};
`, V = c.label`
  /* body/regular/M */
  font-family: ${_.body};
  font-size: ${f.small};
  font-style: normal;
  font-weight: ${B.regular.L.fontWeight};
  line-height: ${W.medium};
`, ee = c.span`
  position: absolute;
  left: 0;
  cursor: ${(e) => e.$isDisabled ? "auto" : "pointer"};
  color: ${(e) => e.$error ? e.theme.components.checkbox.checkmarkErrorColor : e.$isDisabled ? e.theme.components.checkbox.checkmarkDisabledColor : e.theme.components.checkbox.checkmarkColor};
  & img,
  svg {
    height: 20px !important;
    width: 20px !important;
    color: ${(e) => e.$error ? e.theme.components.checkbox.checkmarkErrorColor : e.$isDisabled ? e.theme.components.checkbox.checkmarkDisabledColor : e.theme.components.checkbox.checkmarkColor} !important;
  }
`, oe = c.input`
  appearance: none;
  -moz-appearance: none; /* stylelint-disable-line */
  -webkit-appearance: none; /* stylelint-disable-line */
  height: ${$};
  width: ${$};
  margin: 0;
  box-sizing: border-box;
  outline-style: solid;
  outline-width: ${C["1x"]};
  outline-offset: 0px;
  border-radius: ${v["1x"]};
  overflow: hidden;
  left: 0;
  position: absolute;
  transition: all 0.12s linear;

  &:not(disabled):focus-visible {
    outline-style: solid;
    outline-offset: 1px;
    outline-color: ${(e) => e.$error ? e.theme.components.checkbox.errorFocusColor : e.theme.components.checkbox.focusColor};
    outline-width: ${C["2x"]};
    border-radius: ${v["1x"]};
  }
`, te = c.label`
  display: flex;
  position: relative;
  align-items: flex-start;
  color: ${(e) => e.$isDisabled ? e.theme.components.checkbox.disabledFontColor : e.theme.components.checkbox.fontColor};

  cursor: ${(e) => e.$isDisabled ? "auto" : "pointer"};
  input {
    cursor: ${(e) => e.$isDisabled ? "auto" : "pointer"};
    outline-color: ${(e) => e.$error ? e.theme.components.checkbox.inactiveErrorOutlineColor : e.theme.components.checkbox.inactiveOutlineColor};

    &:checked {
      background-color: ${(e) => e.$error ? e.theme.components.checkbox.activeErrorBackgroundColor : e.$isDisabled ? e.theme.components.checkbox.checkmarkDisabledColor : e.theme.components.checkbox.activeBackgroundColor};
      outline-color: ${(e) => e.$error ? e.theme.components.checkbox.activeErrorOutlineColor : e.theme.components.checkbox.inactiveOutlineHoverColor};
    }

    &:disabled {
      background-color: ${(e) => e.theme.components.checkbox.inactiveDisabledBackgroundColor};
      outline-color: ${(e) => e.theme.components.checkbox.disabledOutlineColor};
      &:checked {
        background-color: ${(e) => e.theme.components.checkbox.activeDisabledBackgroundColor};
        outline-color: ${(e) => e.theme.components.checkbox.activeDisabledBackgroundColor};
        outline-width: 1px;
      }
    }
  }

  &:hover {
    input:not([disabled]) {
      outline-style: solid;
      outline-width: 2px;
      outline-offset: -1px;
      outline-color: ${(e) => e.$error ? e.theme.components.checkbox.inactiveErrorOutlineColor : e.theme.components.checkbox.inactiveOutlineHoverColor};

      &:checked {
        background-color: ${(e) => e.$error ? e.theme.components.checkbox.activeHoverErrorBackgroundColor : e.theme.components.checkbox.activeHoverBackgroundColor};
        outline-color: ${(e) => e.$error ? e.theme.components.checkbox.activeHoverErrorBackgroundColor : e.theme.components.checkbox.activeHoverBackgroundColor};
      }
    }
  }

  &:active {
    label {
      color: ${(e) => e.$isDisabled && e.theme.components.checkbox.checkmarkDisabledActive};
    }
    input {
      &:disabled {
        transition: outline-color 0.12s, background-color 0.12s;
        transition-timing-function: linear;
        outline-width: 1px;
        outline-color: ${(e) => e.theme.components.checkbox.disabledClickColor};

        &:checked {
          outline-width: 1px;
          outline-offset: 0px;
          background-color: ${(e) => e.theme.components.checkbox.disabledClickColor};
        }
      }
    }
  }

  & > span {
    height: ${$};
    width: ${$};
    line-height: ${$};
    position: relative;
    top: 2px;
  }

  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none;
`, ne = c.span`
  margin-left: ${i["8x"]};
  font-family: ${E.inter};
  font-size: ${f.xsmall};
  overflow-wrap: break-word;
  color: ${(e) => e.$isDisabled ? e.theme.components.checkbox.disabledFontColor : e.$error ? e.theme.components.checkbox.errorFontColor : e.theme.components.checkbox.fontColor};
`, re = c.div`
  display: flex;
  flex-direction: row;
  gap: ${i["3x"]};
`, Te = ({
  isDisabled: e = !1,
  checkboxValue: o = h.UNCHECKED,
  error: t = !1,
  helperText: l,
  label: s,
  value: d,
  onChange: b = null,
  isIntermediate: k = !1,
  id: u,
  _width: p
}) => {
  const D = P("checkbox", {
    ariaDisabled: e,
    ariaInvalid: t,
    ariaLabel: s
  }), g = (w) => {
    k ? o = o === h.UNCHECKED ? h.INTERMEDIATE : h.UNCHECKED : o = o === h.UNCHECKED ? h.CHECKED : h.UNCHECKED, b && b(w, o);
  };
  return /* @__PURE__ */ x(Z, { "data-component": "checkbox-wrapper", children: [
    /* @__PURE__ */ x(re, { children: [
      /* @__PURE__ */ n(
        te,
        {
          $isDisabled: e,
          $error: t,
          $checked: o > 0,
          children: /* @__PURE__ */ x("span", { children: [
            /* @__PURE__ */ n(
              oe,
              {
                id: u,
                tabIndex: e ? -1 : 0,
                type: "checkbox",
                "aria-label": "checkbox",
                checked: o > 0,
                disabled: e,
                $error: t,
                value: d ?? o,
                onChange: g,
                ...D
              }
            ),
            o !== h.UNCHECKED && /* @__PURE__ */ n(ee, { $isDisabled: e, $error: t, children: k && o === h.INTERMEDIATE ? /* @__PURE__ */ n(S, {}) : /* @__PURE__ */ n(N, {}) })
          ] })
        }
      ),
      s && /* @__PURE__ */ n(V, { htmlFor: u, children: s })
    ] }),
    l && /* @__PURE__ */ n(ne, { $isDisabled: e, $error: t, children: l })
  ] });
}, ce = () => ` 
  border: 0 none !important;
  margin: unset !important;
  padding: 0 !important;
  margin-inline-start: 0;
  margin-inline-end: 0;
  padding-block-start: 0;
  padding-inline-start: 0;
  padding-inline-end: 0;
  padding-block-end: 0;`, ie = c.fieldset`
  ${ce()}
  display: flex;
  flex-direction: column;
  row-gap: ${i["3x"]};
  > legend {
    margin-bottom: ${i["3x"]} !important;
  }
`, le = c.div`
  display: flex;
  flex-direction: column;
  flex-direction: ${({ $isHorizontal: e }) => e ? "row" : "column"};
  flex-wrap: wrap;
  gap: ${({ $isHorizontal: e }) => e ? `${i["4x"]} ${i["6x"]}` : i["4x"]};
`, ae = c.span`
  font-size: ${f.xsmall};
  font-family: ${E.inter};
  font-weight: ${B.regular.S.fontWeight};
  font-style: normal;
  overflow-wrap: break-word;
  color: ${(e) => e.$error ? e.theme.components.checkbox.errorFontColor : e.theme.components.checkbox.fontColor};
`, se = "CheckboxGroup", Ue = ({
  onChange: e,
  title: o,
  children: t,
  isIntermediate: l = !1,
  helperText: s,
  error: d,
  width: b = 280,
  isHorizontal: k = !1
}) => {
  const u = I(O()), p = I(O(se)), D = `${p.current}_label_id`, [g, w] = R(
    Array.isArray(t) && t.map((r) => ({
      value: r?.props.checkboxValue ?? m.UNCHECKED,
      isIntermediate: l || (r?.props.isIntermediate ?? !1)
    })) || !Array.isArray(t) && [
      {
        value: t?.props.checkboxValue ?? m.UNCHECKED,
        isIntermediate: l || (t?.props.isIntermediate ?? !1)
      }
    ] || []
  ), K = (r) => {
    const a = [...g];
    a[r].value += 1, a[r].value = a[r].isIntermediate ? a[r].value % 3 : a[r].value % 2, w(a);
  }, F = (() => Array.isArray(t) ? t.map((r, a) => {
    const A = a + 1, T = r.props.isDisabled, U = r.props.isIntermediate || l, z = r.props.checkboxValue || g[a].value, M = r.props.error === !1 ? !1 : d;
    return L.cloneElement(r, {
      key: a,
      checkboxValue: z,
      isDisabled: T,
      error: M,
      onChange(H) {
        r.props.onChange?.(H), e?.(H), K(a);
      },
      isIntermediate: U,
      id: r.props.id ?? `FPDSCheckboxComponent${A}-${u.current}`,
      _width: b
    });
  }) : [])();
  return /* @__PURE__ */ x(ie, { children: [
    /* @__PURE__ */ n(
      q,
      {
        labelProp: {
          id: D,
          htmlFor: p.current,
          label: o
        },
        as: "legend"
      }
    ),
    /* @__PURE__ */ n(le, { $isHorizontal: k, children: F }),
    s && /* @__PURE__ */ n(
      ae,
      {
        ...d && {
          "aria-live": "polite",
          role: "alert"
        },
        $error: d,
        children: s
      }
    )
  ] });
};
export {
  Te as Checkbox,
  Ue as CheckboxList,
  Ae as CheckboxOld,
  h as CheckboxStateValues
};
